/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2014, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define({
	'dlg_loading': 'กำลังโหลด...',
	'dlg_close': 'ปิด',
	'dlg_ok': 'ตกลง',
	'dlg_cancel': 'ยกเลิก',
	'dlg_back': 'ย้อนกลับ',
	'dlg_done': 'เสร็จสิ้น',
	'dlg_save': 'บันทึก',

	// Slider
	'sliderRegionLabel': 'ตัวควบคุมสไลเดอร์ ใช้ลูกศรขวาและซ้ายเพื่อย้ายตัวจัดการสไลเดอร์',
	'sliderHandleLabel': 'ตัวจัดการสไลเดอร์',
	'a11ySliderHandleLabel': 'ตัวจัดการสไลเดอร์ %{sliderValue}',
	'sliderInputLabel': 'ค่า',

	// Side bar
	'sidebarAdd': 'เพิ่ม',
	'clearTextFilterValue': 'เคลียร์',
	'missingDataSetData': 'ข้อมูลสำหรับชุดข้อมูลนี้ไม่พร้อมใช้งาน รีเฟรชชุดข้อมูล หรือติดต่อผู้ดูแลระบบของคุณสำหรับการเข้าถึงแหล่งข้อมูล',

	// Toolbar
	'toolbarRegionLabel': 'แถบเครื่องมือ',
	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',
	//TextToolbar
	'fontSelect': 'ตระกูลของฟอนต์',
	'fontFamilyStyle': 'สไตล์ฟอนต์',
	'regularFontStyle': 'ปกติ',
	'fontSizeSelect': 'ขนาดของฟอนต์',
	'fontColorSelect': 'สี',
	'fontStyle': 'สไตล์',
	'colorPickerTitle': 'การเลือกสี',
	'bold': 'ตัวหนา',
	'italic': 'ตัวเอียง',
	'underline': 'ขีดเส้นใต้',
	'fontAlignment': 'การจัดวาง',
	'justifyLeft': 'จัดวางชิดซ้าย',
	'justifyCenter': 'จัดวางไว้กึ่งกลาง',
	'justifyRight': 'จัดวางชิดขวา',
	'insertOrderedList': 'รายการแบบเรียงลำดับ',
	'insertUnorderedList': 'รายการแบบไม่เรียงลำดับ',
	'fontColorPicker': 'ตัวเลือกสี',
	'textWrap': 'ตัดข้อความ',
	'restore': 'เรียกคืนค่าดีฟอลต์',
	'textAutoFontSize': 'อัตโนมัติ',
	'textDefaultFontSize': 'ค่าดีฟอลต์',
	'textItemTitle': 'ชื่อเรื่อง',
	'textLabelShadow': 'เงาของเลเบล',
	'textContrastLabelColor':'สีความเปรียบต่าง',
	'toggleOn': 'เปิด',
	'toggleOff': 'ปิด',
	'contrastLabelColorInfo': 'ปรับสีของเลเบลโดยอัตโนมัติเพื่อเสริมความสามารถในการเข้าถึง ซึ่งจะแทนที่สีของฟอนต์',
	'labelShadowInfo':'เพิ่มเงาให้กับข้อความเพื่อเสริมความสามารถในการเข้าถึง',
	'applyToAll':'ปรับใช้การกำหนดลักษณะกับแกนทั้งหมด',

	// Top Bottom
	'topbottomNumberOfResultsLabel': 'จำนวนผลลัพธ์ (%{lower} - %{higher})',
	'topbottomPercentLabel': 'เปอร์เซ็นต์ (%{lower}% - %{higher}%)',
	'topbottomSelectOption': 'อ็อพชันด้านบนหรือด้านล่าง',
	'topbottomOptionLabel': 'แสดง',
	'searchByLabel': 'โดย',
	'searchNoMatches': 'ไม่พบรายการที่ตรงกัน',
	'topbottomRankColumnLabel': 'เพิ่มคอลัมน์การจัดอันดับเข้ากับตาราง',
	'topbottomNone': 'ไม่มี',
	'topCount': 'การนับด้านบน',
	'topPercent': 'ด้านบน %',
	'bottomCount': 'การนับด้านล่าง',
	'bottomPercent': 'ด้านล่าง %',
	'searchColumn': 'ค้นหาคอลัมน์',
	'searchColumnAriaLabel': 'ค้นหาคอลัมน์ พิมพ์ชื่อของคอลัมน์ที่จะค้นหา จากนั้น ใช้ลูกศรลงเพื่อค้นหาคอลัมน์ในรายการ',
	'searchColumnQualifiedLabel': '%{columnLabel} (%{columnId})',
	'rankColumnLabel': 'อันดับ (%{columnLabel})',
	'topbottomClearLabel': 'รีเซ็ต',

	// Format
	'formatAuto': 'อัตโนมัติ',
	'formatConvertPercent': 'แปลงทศนิยมเป็นเปอร์เซ็นต์',
	'formatAbbreviate': 'ย่อ',
	'formatUseGrouping': 'ใช้ตัวคั่นหลักพัน',
	'dateStyle': 'สไตล์วันที่',
	'dateTimeStyle': 'สไตล์ของวันที่/เวลา',
	'formatMissingValueCharactersInfo': 'อักขระของค่าที่หายไประบุอักขระที่จะแสดงผลเมื่อค่าหายไป',
	'currencySymbolLabel': 'สัญลักษณ์สกุลเงิน',
	'customSymbolPlaceholder': 'เพิ่มสัญลักษณ์',
	'customSymbolLabelInfo': 'ระบุอักขระตัวเดียวหรือหลายตัวที่จะใช้เป็นสัญลักษณ์แบบกำหนดเอง สัญลักษณ์นี้จะนำหน้าตัวเลขและเครื่องหมายใด ๆ',
	'numberLabel': 'เลเบลตัวเลข',
	'numberPositionLabel': 'ตำแหน่งเลเบล',
	'negativeSignPosition': 'ตำแหน่งเครื่องหมายลบ',
	'negativeSign': 'สัญลักษณ์เครื่องหมายลบ',
	'numberLabelInfo': 'ระบุเลเบลสำหรับหมายเลขที่จัดรูปแบบและตำแหน่งที่วางด้านหน้าหรือด้านหลังขึ้นอยู่กับตำแหน่งเลเบล',
	'nullValueDefault': '<ดีฟอลต์>',
	'nullValueContent': '(ไม่มีค่า)',
	'default': 'ดีฟอลต์',
	'beginning': 'เริ่มต้น',
	'end': 'สิ้นสุด',
	'formatLabel': 'เลือกรูปแบบ',

	// More data indicator
	'moreDataIndicator': 'ข้อมูลของคุณถูกตัดออกที่ %{threshold} ไอเท็ม ใช้กับตัวกรองเพื่อแสดงข้อมูลให้น้อยลง',

	// Expanded View / Focus mode
	'evCollapse': 'ยุบ',
	'duplicate': 'ทำซ้ำ',
	'copyOf': 'สำเนาของ %{name}',
	'unableToDuplicateBoard': 'ไม่สามารถทำสำเนา "%{name}"',

	// Widget list
	'errorLoadingWidgetList': 'เราไม่สามารถโหลดอ็อบเจ็กต์',

	// Custom widgets
	'customWidget': 'วิดเจ็ตแบบกำหนดเอง',

	// Auto group
	'group': 'กลุ่ม',

	// TODO: Carbon design removes Font Family subClass, no longer needed when FF 'PropertiesV2' is enabled
	// START: Remove FontFamilySubClass
	'textFontFamilySubClassHairline': 'เส้นบางเฉียบ',
	'textFontFamilySubClassThin': 'บาง',
	'textFontFamilySubClassThinItalic': 'ตัวเอียงบาง',
	'textFontFamilySubClassExtraLight': 'บางพิเศษ',
	'textFontFamilySubClassExtraLightItalic': 'ตัวเอียงบางพิเศษ',
	'textFontFamilySubClassLight': 'บาง',
	'textFontFamilySubClassLightItalic': 'บางเอียง',
	'textFontFamilySubClassRegular': 'ปกติ',
	'textFontFamilySubClassRegularItalic': 'ตัวเอียงปกติ',
	'textFontFamilySubClassItalic': 'ตัวเอียง',
	'textFontFamilySubClassMedium': 'ปานกลาง',
	'textFontFamilySubClassMediumItalic': 'ตัวเอียงขนาดกลาง',
	'textFontFamilySubClassHeavy': 'ตัวหนา',
	'textFontFamilySubClassHeavyItalic': 'ตัวเอียงหนา',
	'textFontFamilySubClassDemiBold': 'ตัวหนาครึ่งหนึ่ง',
	'textFontFamilySubClassDemiBoldItalic': 'ตัวเอียงหนาครึ่งหนึ่ง',
	'textFontFamilySubClassBold': 'ตัวหนา',
	'textFontFamilySubClassBoldItalic': 'ตัวเอียงหนา',
	'textFontFamilySubClassExtraBold': 'ตัวหนาพิเศษ',
	'textFontFamilySubClassExtraBoldItalic': 'ตัวเอียงหนาพิเศษ',
	'textFontFamilySubClassBlack': 'สีดำ',
	'textFontFamilySubClassBlackItalic': 'ตัวเอียงสีดำ',
	'textFontFamilySubClassStencil': 'ลายฉลุ',
	// END: Remove FontFamilySubClass
});
